// @ts-nocheck
/**
 * Tiny status pill for a tie-out result, shared by the ledger rows and the
 * per-period detail. Reuses the recon-badge color language (green pass / red
 * fail) so the whole FinalMappingCard speaks one badge dialect.
 */
import React from 'react';
import { CheckCircle, XCircle, Link2, AlertTriangle } from 'lucide-react';

export const TIE_META = {
  tie: { label: 'Ties', tone: 'tie', icon: CheckCircle },
  flag: { label: 'Flag', tone: 'flag', icon: XCircle },
  not_referenced: { label: 'Not linked', tone: 'muted', icon: Link2 },
  source_unavailable: { label: 'No source', tone: 'warn', icon: AlertTriangle },
};

const TieBadge = ({ status, compact = false }) => {
  const meta = TIE_META[status] || TIE_META.not_referenced;
  const Icon = meta.icon;
  return (
    <span className={`tieout-badge tieout-badge-${meta.tone}`}>
      <Icon size={11} />
      {!compact && <span>{meta.label}</span>}
    </span>
  );
};

export default TieBadge;
